/**
 * 📜 Add landmark role to outer container.
 *
 * @function addLandmarkRole
 * @description Adds the role and aria-label attributes to the notification bar element.
 * @returns {void}
 */
function addLandmarkRole() {
  const el = document.querySelector('.easy-notification-bar');
  if (el != null) {
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Notification');
  }
}

/**
 * 📜 Skip to content link and move it to the top of the page DOM.
 *
 * @function skipToContent
 * @description Moves the skip link to the top of the page DOM to be the first tabbable element.
 * @returns {void}
 */
function skipToContent() {
  // Skip to content link
  const header = document.querySelector('header.site-header');
  header?.nextElementSibling.setAttribute('id', 'wp--skip-link--target');

  // Move skip link to top of page DOM in order to be first tabbable element
  // given that the Cookie Yes plugin appends focusable content dynamically
  // to the top.
  const skipLink = document.querySelector('.skip-link.screen-reader-text');
  skipLink?.parentNode.prepend(skipLink);
}

document.addEventListener('DOMContentLoaded', addLandmarkRole);
document.addEventListener('load', skipToContent, { once: true, capture: true });
